module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['common-header', _vm.theme, _vm.rootClass]
  }, [_c('div', {
    staticClass: "common-header-wrapper",
    style: (_vm.rootStyle)
  }, [_vm._t("left", [_c('div', {
    staticClass: "icon-mobile",
    class: {
      'is-active': _vm.isMenuMobileShow
    },
    on: {
      "click": function($event) {
        _vm.isMenuMobileShow = !_vm.isMenuMobileShow
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('a', {
    staticClass: "common-logo",
    style: (_vm.logoStyle),
    attrs: {
      "href": _vm.logoHref || "https://geekbang.org/"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "menu"
  }, [_vm._l((_vm.menu), function(item, i) {
    return _c('a', {
      key: i,
      class: [{
        hidden: !_vm.showMenu
      }, {
        on: _vm.location === item.link
      }, _vm.pcMenuStyle],
      attrs: {
        "href": item.link,
        "target": "_black"
      },
      on: {
        "click": function($event) {
          _vm.menuClick(item, $event)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _vm._t("search")], 2), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [(!_vm.navRouterLink) ? [(!_vm.loginUser) ? _c('span', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "pc",
    attrs: {
      "href": ("https://account.geekbang.org/signin?redirect=" + (encodeURIComponent(_vm.location)))
    }
  }, [_vm._v("\n              登录\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "pc line"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "pc",
    attrs: {
      "href": ("https://account.geekbang.org/signup?redirect=" + (encodeURIComponent(_vm.location)))
    }
  }, [_vm._v("\n              注册\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "mobile",
    attrs: {
      "href": ("https://account.geekbang.org/signin?redirect=" + (encodeURIComponent(_vm.location)))
    }
  }, [_vm._v("\n              登录\n            ")])]) : _c('div', {
    staticClass: "profile"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "profile-dropdown"
  }, [_c('i', {
    staticClass: "arrow"
  }), _vm._v(" "), _vm._t("profile-dropdown-eachlist"), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://account.geekbang.org/logout?redirect=" + (encodeURIComponent(_vm.location)))
    }
  }, [_c('i', {
    staticClass: "icon-font"
  }, [_vm._v("")]), _vm._v("\n                退出登录\n              ")])], 2)])] : [(!_vm.loginUser) ? _c('span', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "pc",
    attrs: {
      "to": "/signin"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('a', {
    staticClass: "pc line"
  }, [_vm._v("|")]), _vm._v(" "), _c('router-link', {
    staticClass: "pc",
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('router-link', {
    staticClass: "mobile",
    attrs: {
      "to": "/signin"
    }
  }, [_vm._v("登录")])], 1) : _c('div', {
    staticClass: "profile"
  }, [_vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "profile-dropdown"
  }, [_c('i', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/dashboard/info"
    }
  }, [_c('i', {
    staticClass: "icon-font"
  }, [_vm._v("")]), _vm._v("\n                基本信息\n              ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/dashboard/setting"
    }
  }, [_c('i', {
    staticClass: "icon-font"
  }, [_vm._v("")]), _vm._v("\n                账号设置\n              ")]), _vm._v(" "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "icon-font"
  }, [_vm._v("")]), _vm._v("\n                退出登录\n              ")])], 1)])]], 2)]), _vm._v(" "), (_vm.isMenuMobileShow) ? _c('div', {
    staticClass: "menu-mobile",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.blackCover($event)
      }
    }
  }, [_c('ul', [_vm._l((_vm.menu), function(item, i) {
    return _c('li', {
      key: i,
      class: {
        hidden: !_vm.showMenu
      }
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_black"
      },
      on: {
        "click": function($event) {
          _vm.menuClick(item, $event)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), _vm._v(" "), _vm._t("searchmobile")], 2)]) : _vm._e()], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://account.geekbang.org/dashboard"
    }
  }, [_c('i', {
    staticClass: "icon-font icon-profile"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://account.geekbang.org/dashboard/info"
    }
  }, [_c('i', {
    staticClass: "icon-font"
  }, [_vm._v("")]), _vm._v("\n                基本信息\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://account.geekbang.org/dashboard/setting"
    }
  }, [_c('i', {
    staticClass: "icon-font"
  }, [_vm._v("")]), _vm._v("\n                账号设置\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "icon-font icon-profile"
  }, [_vm._v("")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27c79895","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/geekbang-base/src/components/Header/Header.vue
// module id = 442
// module chunks = 1